import PropTypes from "prop-types";
import React from "react";

import UpButton from "../up-button";
import {
  Backdrop,
  Content,
  Footer,
  Heading,
  HelpWidgetStyle,
  ModalContent,
  ModalWrapper
} from "./styles";

interface ConfirmModalBaseProps {
  children: React.ReactNode;
  close: () => void;
  headingColor?: string;
  height?: string;
  leftButtonDisabled?: boolean;
  loading?: boolean;
  rightButtonDisabled?: boolean;
  rightButtonOnClick: () => void;
  rightButtonText: React.ReactNode;
  title: React.ReactNode;
  visible: boolean;
}

interface ConfirmModalWithLeftButtonProps {
  leftButtonOnClick: () => void;
  leftButtonText: React.ReactNode;
}

interface ConfirmModalWithoutLeftButtonProps {
  leftButtonOnClick?: undefined;
  leftButtonText?: undefined;
}

export type ConfirmModalProps = ConfirmModalBaseProps &
  (ConfirmModalWithLeftButtonProps | ConfirmModalWithoutLeftButtonProps);

const ConfirmModal = (props: ConfirmModalProps) => {
  const {
    title,
    children,
    loading,
    close,
    rightButtonOnClick,
    leftButtonDisabled,
    rightButtonDisabled,
    rightButtonText,
    visible,
    height,
    headingColor
  } = props;

  if (!visible) {
    return null;
  }

  const checkLeftButton = Boolean(props.leftButtonText && props.leftButtonText !== "");

  return (
    <ModalWrapper>
      <HelpWidgetStyle />
      <Backdrop
        onClick={() => {
          if (!loading) {
            close();
          }
        }}
      />
      <ModalContent height={height}>
        <Heading headingColor={headingColor}>{title}</Heading>
        <Content>{children}</Content>
        <Footer>
          {props.leftButtonText && props.leftButtonText !== "" ? (
            <UpButton
              padding="5px 10px"
              type="button"
              disabled={loading || leftButtonDisabled}
              onClick={props.leftButtonOnClick}
              value={props.leftButtonText}
            />
          ) : null}
          <UpButton
            padding="5px 10px"
            margin={checkLeftButton ? "0" : "0 0 0 auto"}
            type="button"
            disabled={loading || rightButtonDisabled}
            loading={loading}
            onClick={rightButtonOnClick}
            value={rightButtonText}
          />
        </Footer>
      </ModalContent>
    </ModalWrapper>
  );
};

ConfirmModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  leftButtonOnClick: PropTypes.func,
  rightButtonOnClick: PropTypes.func.isRequired,
  leftButtonDisabled: PropTypes.bool,
  rightButtonDisabled: PropTypes.bool,
  leftButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  rightButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  height: PropTypes.string,
  headingColor: PropTypes.string
};

export default ConfirmModal;
